import * as React from "react";
import { forwardRef, memo } from "react";
const SvgArrowDropDown = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M452-388 348-492q-19-19-8.5-43.5T377-560h206q27 0 37.5 24.5T612-492L508-388q-6 6-13 9t-15 3-15-3-13-9" })));
const ForwardRef = forwardRef(SvgArrowDropDown);
const Memo = memo(ForwardRef);
export default Memo;
